import * as confluenceShortcuts from './confluence-shortcuts.ts';
import { getShortcutValues } from './util.ts';

export const ALLOW_SHORTCUTS_CLASS = 'shortcuts-are-allowed';
export const ALLOW_SHORTCUTS_CLASS_IN_MODAL = 'shortcuts-are-allowed-in-modal';
export const PROSEMIRROR_FOCUSED_CLASS = 'ProseMirror-focused';
export const MOUSETRAP_ALLOWED_ELEMENTS: string[] = [
	PROSEMIRROR_FOCUSED_CLASS,
	ALLOW_SHORTCUTS_CLASS,
];

export const MOUSETRAP_ALLOWED_MODALS: string[] = [ALLOW_SHORTCUTS_CLASS_IN_MODAL];

export const RESERVED_SHORTCUTS: string[] = Object.values(confluenceShortcuts).reduce(
	getShortcutValues,
	[],
);
